module.exports = __webpack_public_path__ + "static/media/F-1.4955eadd.webp";